import { Injectable } from '@angular/core';
import Gleap from 'gleap';
import { AuthenticatedUser } from '@generated/graphql';

@Injectable({
  providedIn: 'root',
})
export class GleapService {
  public setIdentify(data: AuthenticatedUser): void {
    const user = data.user;

    if (!user) return;

    Gleap.identify(user.id, {
      email: user.email,
      name: user.name,
      avatar: user.avatarUrl,
      companyId: data.accountId,
      createdAt: new Date(),
    });
  }

  public clearIdentify(): void {
    Gleap.clearIdentity();
  }
}
